import React from 'react';

export const hasMarkdown = (text: string): boolean => {
  if (!text || typeof text !== 'string') {
    return false;
  }

  const underlineRegex = /\[u\].*?\[\/u\]/;
  const italicRegex = /\*[^*]+\*/;  
  const boldRegex = /\*\*[^*]+\*\*/;

  return underlineRegex.test(text) || italicRegex.test(text) || boldRegex.test(text);
}

export const transformToMarkdown = (text: string): string | React.ReactElement => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  if (!hasMarkdown(text)) {
    return text;
  }

  let transformedText = text;

  transformedText = transformedText.replace(/\[u\](.*?)\[\/u\]/g, '<u>$1</u>'); // underline
  transformedText = transformedText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>'); // bold
  transformedText = transformedText.replace(
    /(^|[^*])\*([^*]+)\*(?!\*)/g,
    (_m: string, pre: string, text: string) => `${pre}<em>${text}</em>`
  ) // italic
  return createMarkdownLabel(transformedText);
}

export const createMarkdownLabel = (markdownText: string): React.ReactElement => {
    return React.createElement('span', {
      style: { marginLeft: 4 },
      dangerouslySetInnerHTML: { __html: markdownText }
    });
  }